import React from 'react';
import './css/UpcomingCourses.scss';
import ASK1 from './images/courses1.png';
import ASK2 from './images/courses2.png';
import ASK3 from './images/courses3.png';

const Courses=(props)=>{
    return(
        <div className="container upcomingcourses" id="courses">
            <h1 className="Upcoming-online-course">Upcoming online course</h1>
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="card-img-top image" src={ASK1} alt="ASK1"></img>
                        <div className="card-body" style={{borderBottomRightRadius:"12px",borderBottomLeftRadius:"12px",backgroundColor:"#f3f3f3"}}>
                        <h5 className="card-text Askademia-Revision-Courses">Askademia Revision Courses</h5>
                    </div>
                </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 coloumns">
                <div className="card coloumn">
                    <img className="card-img-top image" src={ASK2} alt="ASK2"></img>
                    <div className="card-body" style={{borderBottomRightRadius:"12px",borderBottomLeftRadius:"12px",backgroundColor:"#f3f3f3"}}>
                    <h5 className="card-text Askademia-Revision-Courses">Askademia Revision Courses</h5>
                </div>
            </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 coloumns">
            <div className="card coloumn">
                <img className="card-img-top image" src={ASK3} alt="ASK3"></img>
                <div className="card-body" style={{borderBottomRightRadius:"12px",borderBottomLeftRadius:"12px",backgroundColor:"#f3f3f3"}}>
                <h5 className="card-text Askademia-Revision-Courses">Askademia Revision Courses</h5>
            </div>
        </div>
        </div>
        <h2 className="Show-all-online-courses"><b>Show all online courses</b> &gt;</h2>
        </div>
        </div>
        );
    }
    export default Courses;